import styles from "./errorMessage.module.css";
export const ErrorMessage = () => {
  return (
    <div className={styles.error_container}>
      <h2>Un erreur s'est produite, veuillez réessayer ultérieurement</h2>
    </div>
  );
};
